import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Select,
  MenuItem,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Autocomplete,
  TextField,
  Dialog,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";

import PermissionsApi from "api/permissions";
import ProcesosApi from "api/procesosApi";

const AsignarProcesoModal = ({ open, onClose, procesoIdentificador, onSuccess }) => {
  const [proceso, setProceso] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [tipoResponsable, setTipoResponsable] = useState("");
  const [nuevoResponsable, setNuevoResponsable] = useState(null);
  //const [listaResponsables, setListaResponsables] = useState([]);
  const [error, setError] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (procesoIdentificador) {
      const fetchInitialData = async () => {
        try {
          const [procesoResp, responsablesRes, gruposRes] = await Promise.all([
            ProcesosApi.fetchProcesoByIdentificador(procesoIdentificador),
            ProcesosApi.fetchResponsables({
              roles: ["ASESOR(A) EXTERNO", "ASESOR(A) INTERNO", "ASISTENTE"],
            }),
            PermissionsApi.fetchGroups(),
          ]);
          setProceso(procesoResp.data);
          setUsuarios(responsablesRes.data || []);
          setNuevoResponsable(null);
          // Lista de nombres de grupos a excluir
          const gruposExcluidos = ["ADMIN", "INVITADO"];
          // Filtrar los grupos que NO estén en la lista de exclusión
          const gruposFiltrados = (gruposRes.data || []).filter(
            (grupo) => !gruposExcluidos.includes(grupo.name)
          );
          setGrupos(gruposFiltrados);
          //setListaResponsables(fetchedProceso.lista_responsables_detalle || []);
        } catch (error) {
          console.error("Error al obtener los datos iniciales:", error);
          setError(obtenerMensajeError(error, "Error al cargar los datos iniciales."));
        }
      };

      fetchInitialData();
    }
  }, [procesoIdentificador]);

  // const handleResponsablesChange = (event) => {
  //   const selectedIds = event.target.value; // Array de IDs seleccionados
  //   // Filtra usuarios para obtener los objetos completos de los IDs seleccionados
  //   const selectedUsers = usuarios.filter((user) => selectedIds.includes(user.id));
  //   setListaResponsables(selectedUsers);
  // };

  const handleTipoResponsableChange = (event) => {
    setTipoResponsable(event.target.value);
    setNuevoResponsable(null); // Limpiar la selección actual
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (nuevoResponsable == null) {
      setError("Debes registrar un Nuevo Responsable.");
      return;
    }
    const datos = {
      operacion: "ASIGNAR_PROCESO",
      id_proceso: proceso.id,
      //responsable: nuevoResponsable,
      responsable: {
        tipo: tipoResponsable,
        id_usuario: tipoResponsable === "USUARIO" ? nuevoResponsable?.id : null,
        str_grupo: tipoResponsable === "GRUPO" ? nuevoResponsable?.name : null,
      },
      //lista_responsables: listaResponsables.map((user) => user.id),
    };
    const confirmAction = window.confirm(
      `¿Está seguro(a) de asignar el Proceso ${proceso.identificador}?`
    );
    if (!confirmAction) return;
    try {
      setLoading(true);
      const response = await ProcesosApi.operarProceso(datos);
      if (response.status === 201 && response.data) {
        alert("Operación realizada con éxito");
        resetState();
        onSuccess();
      }
    } catch (error) {
      console.error("Error al asignar el Proceso:", error);
      setError(obtenerMensajeError(error, "Error al asignar el Proceso."));
    } finally {
      setLoading(false);
    }
  };

  const resetState = () => {
    setError(undefined);
    //setListaResponsables([]);
    setTipoResponsable(null);
    setNuevoResponsable(null);
  };

  const hCClose = () => {
    resetState();
    onClose();
  };

  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 9999, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog open={open} onClose={hCClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <h3>ASIGNASIÓN a ASISTENTE, ASESOR o a un GRUPO</h3>
          <strong>PROCESO: {proceso ? proceso.identificador : "No tiene Proceso"}</strong>
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={12}>
                {error && (
                  <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                  </Alert>
                )}
              </Grid>
            </Grid>
            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>Responsable Actual</Grid>
              <Grid size={8}>
                <SuiBox mb={2}>
                  {proceso && proceso.responsable_detalle
                    ? proceso.responsable_detalle.usuario
                      ? proceso.responsable_detalle.usuario.nombre_completo
                      : proceso.responsable_detalle.grupo
                      ? proceso.responsable_detalle.grupo.name
                      : "No tiene."
                    : "No tiene."}
                </SuiBox>
              </Grid>
            </Grid>
            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>Tipo de Responsable</Grid>
              <Grid size={8}>
                <SuiBox mb={2}>
                  <Select value={tipoResponsable} onChange={handleTipoResponsableChange}>
                    <MenuItem value="">Seleccione Tipo Responsable</MenuItem>
                    <MenuItem value="USUARIO">Usuario</MenuItem>
                    <MenuItem value="GRUPO">Grupo</MenuItem>
                  </Select>
                </SuiBox>
              </Grid>
            </Grid>
            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>Nuevo Responsable</Grid>
              <Grid size={8}>
                <SuiBox mb={2}>
                  <Autocomplete
                    disablePortal={false}
                    options={tipoResponsable === "USUARIO" ? usuarios : grupos}
                    getOptionLabel={(option) =>
                      tipoResponsable === "USUARIO"
                        ? option?.nombre_completo || ""
                        : option?.name || ""
                    }
                    sx={{ mb: 3 }}
                    renderInput={(params) => <TextField {...params} />}
                    value={nuevoResponsable}
                    onChange={(_, newValue) => setNuevoResponsable(newValue)}
                    PopperProps={{
                      modifiers: [
                        {
                          name: "preventOverflow",
                          options: {
                            boundary: "viewport",
                          },
                        },
                      ],
                      sx: { zIndex: 1600 },
                    }}
                  />
                  {/* <Autocomplete
                    disablePortal
                    options={usuarios}
                    getOptionLabel={(option) => option?.nombre_completo || ""}
                    sx={{ mb: 3 }}
                    renderInput={(params) => <TextField {...params} />}
                    value={nuevoResponsable}
                    onChange={(_, newValue) => hCNuevoResponsable(newValue)}
                  /> */}
                </SuiBox>
              </Grid>
            </Grid>
            {/* <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>Lista Responsables</Grid>
              <Grid size={8}>
                <Select
                  multiple
                  value={listaResponsables.map((user) => user.id)} // Usar IDs para el control del valor
                  onChange={handleResponsablesChange}
                  renderValue={(selected) =>
                    selected
                      .map((id) => usuarios.find((user) => user.id === id)?.nombre_completo)
                      .join(", ")
                  }
                >
                  {usuarios.map((usuario) => (
                    <MenuItem key={usuario.id} value={usuario.id}>
                      <Checkbox checked={listaResponsables.some((item) => item.id === usuario.id)} />
                      <ListItemText primary={usuario.nombre_completo} />
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid> */}
          </DialogContent>
          <DialogActions>
            <SuiButton onClick={hCClose} buttonColor="light">
              Cancelar
            </SuiButton>
            <SuiButton type="submit" variant="gradient" buttonColor="dark">
              {proceso ? "Asignar" : "..."}
            </SuiButton>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

AsignarProcesoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  procesoIdentificador: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default AsignarProcesoModal;
